import { axios } from '../axios';

// Fetch all countries
export const getAllCountries = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/country-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all countries
                    sortBy: 1,
                    sortField: 'name',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all sectors
export const getAllSectors = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/sectors-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all sectors
                    sortBy: 1,
                    sortField: 'name',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all regions
export const getAllRegions = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/regions-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all regions
                    sortBy: 1,
                    sortField: 'name',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all CPV codes
export const getAllCPVCodes = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/cpv-codes-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all CPV codes
                    sortBy: 1,
                    sortField: 'code',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all funding agencies
export const getAllFundingAgencies = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/funding-agency-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all funding agencies
                    sortBy: 1,
                    sortField: 'title',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all states
export const getAllStates = async () => {
    return new Promise(async (res, rej) => {
        try {
            const response = await axios.get('/masters/states-all', {
                params: {
                    pageNo: 0,
                    limit: 1000, // Get all states
                    sortBy: 1,
                    sortField: 'name',
                    keywords: '',
                },
            });
            res(response.data.result.result || []);
        } catch (error) {
            rej(error);
        }
    });
};

// Fetch all master data at once
export const fetchAllMasterData = async () => {
    try {
        const [countries, sectors, regions, cpvCodes, fundingAgencies, states] =
            await Promise.all([
                getAllCountries(),
                getAllSectors(),
                getAllRegions(),
                getAllCPVCodes(),
                getAllFundingAgencies(),
                getAllStates(),
            ]);

        return {
            countries:
                countries
                    ?.filter((c) => c && c.name)
                    .map((c) => ({ label: c.name, value: c.name })) || [],
            sectors:
                sectors
                    ?.filter((s) => s && s.name)
                    .map((s) => ({ label: s.name, value: s.name })) || [],
            regions:
                regions
                    ?.filter((r) => r && r.name)
                    .map((r) => ({ label: r.name, value: r.name })) || [],
            cpvCodes:
                cpvCodes
                    ?.filter((c) => c && c.code)
                    .map((c) => ({ label: c.code, value: c.code })) || [],
            fundingAgencies:
                fundingAgencies
                    ?.filter((f) => f && f.title)
                    .map((f) => ({ label: f.title, value: f.title })) || [],
            states:
                states
                    ?.filter((s) => s && s.name)
                    .map((s) => ({ label: s.name, value: s.name })) || [],
        };
    } catch (error) {
        console.error('Error fetching master data:', error);
        return {
            countries: [],
            sectors: [],
            regions: [],
            cpvCodes: [],
            fundingAgencies: [],
            states: [],
        };
    }
};
